import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import styled, { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  em {
    font-style: inherit;
  }
`;
export const SectionHeader = styled.div`
    margin-bottom: -3px;
`;
export const CouponIconContainer = styled.div(({ theme }) => ({
    marginTop: theme.spacing.xxSmall,
}));

export const CardContainer = styled.div(({ theme }) => {
    return {
        marginTop: theme.spacing.medium,
    };
});

export const StyledRemoveText = styled(Text)(() => {
    return {
        color: "rgba(241, 87, 0, 1)",
    };
});

export const Row = styled.div`
    display: flex;
    align-items: center;
    flex-direction: row;
`;

export const SavingsTextWrapper = styled.div(() => {
    return {
        flex: 1,
        alignItems: "flex-start",
    };
});

export const CouponAppliedWrapper = styled.div(({ theme }) => {
    return {
        boxShadow: theme.elevation[theme.colorMode].skim.boxShadow,
        borderRadius: theme.spacing.large,
        background: theme.colors[theme.colorMode].background_Primary,
        padding: theme.spacing.medium,
    };
});

export const NonAppliedSubtitleContainer = styled.div`
    margin-top: 1px;
`;

export const NonAppliedContainer = styled.div<{
    showShakeAnimation?: boolean;
}>`
    display: grid;
    grid-template-columns: 94% 6%;
    justify-content: center;
    align-items: center;
    background-size: cover;
    border-radius: ${({ theme }) => theme.spacing.large};
    background: ${({ theme }) => theme.colors[theme.colorMode].background_Primary};
    padding: ${({ theme }) => theme.spacing.medium};
    box-shadow: ${({ theme }) => theme.elevation[theme.colorMode].skim.boxShadow};
    transition: all 0.2s ease;

    ${({ showShakeAnimation }) =>
        showShakeAnimation &&
        `
        animation: shake 1.2s ease 2s 1;
        will-change: transform;
    `}

    @keyframes shake {
        0% {
            transform: translateX(0);
        }
        10% {
            transform: translateX(6px);
        }
        20% {
            transform: translateX(-6px);
        }
        30% {
            transform: translateX(6px);
        }
        40% {
            transform: translateX(-6px);
        }
        50% {
            transform: translateX(6px);
        }
        60% {
            transform: translateX(-6px);
        }
        70% {
            transform: translateX(6px);
        }
        80% {
            transform: translateX(-6px);
        }
        90% {
            transform: translateX(6px);
        }
        100% {
            transform: translateX(0);
        }
    }
`;

export const SavingsTextContainer = styled.div(() => {
    return {
        display: "grid",
        gridTemplateColumns: "7% 93%", // Adjust columns as needed
        justifyContent: "center" /* Centers items horizontally */,
        alignItems: "center" /* Centers items vertically */,
        backgroundSize: "cover",
    };
});
export const CouponHeader = styled.div(() => {
    return {
        display: "grid",
        gridTemplateColumns: "70% 30%", // Adjust columns as needed
        justifyContent: "center" /* Centers items horizontally */,
        alignItems: "center" /* Centers items vertically */,
        backgroundSize: "cover",
    };
});

export const JustifyContentCenter = styled.div(() => ({
    display: "flex",
    justifyContent: "center",
}));

export const TouchableOpacity = styled.div(() => {
    return { marginLeft: "auto" };
});

export const CouponImgContainer = styled.div`
    margin-right: 3px;
    display: flex;
    align-items: center;
`;

interface Icouponsubtitle {
    subtitleColor: string;
}
export const StyledText = styled(Text)(({ theme }) => ({
    marginTop: theme.spacing.xxSmall,
    "& em": {
        fontWeight: "bold",
    },
}));

export const StyledSubtitleText = styled(Text)<Icouponsubtitle>(({ theme, subtitleColor }) => ({
    marginTop: theme.spacing.xxSmall,
    color: subtitleColor,
}));
